import { Component, OnInit } from '@angular/core';
import {GlobalService} from "../../../global.service";
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-tecno-cup',
  templateUrl: './tecno-cup-iraq.component.html',
  styleUrls: ['./tecno-cup-iraq.component.scss']
})
export class TecnoCupIraqComponent implements OnInit {
  loading = false
  constructor(public globalService:GlobalService , private titleService: Title) {
    this.titleService.setTitle('tecno-pubg-mobile-cup-2-iraq')

  }

  ngOnInit(): void {

      if (localStorage.getItem('language')) {
        this.globalService.customLang = require('./lang/' + localStorage.getItem('language') + '.json');
        this.globalService.langChosen = localStorage.getItem('language');
      } else {
        localStorage.setItem('language' , 'ar')
        console.log(localStorage.getItem('language'))
        this.globalService.customLang = require('./lang/' + localStorage.getItem('language') + '.json');
      }


  }
  languageChange(value) {
    console.log(value)
    if (this.globalService.isBrwoser) {
      this.globalService.langChosen = value;
      this.globalService.customLang = require('./lang/' + value + '.json');
      this.globalService.language = value;
      localStorage.setItem('language', value);

    }
  }
}
